export const BECOME = "become"
export const LOOK_FOR = "look_for"
export const SELL_SHARES = "sell_shares"
